<template>
    <div class="user">
        <div class="condition">
            <div class="item">
                <div class="label">用户ID:</div>
                <el-input v-model="conditionData.userId" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">性别:</div>
                <el-select v-model="conditionData.gender" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in genderList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">手机号码:</div>
                <el-input v-model="conditionData.phone" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">省份:</div>
                <el-input v-model="conditionData.province" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">城市:</div>
                <el-input v-model="conditionData.City" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="warning" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <!-- <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogShow()" v-if="mipu_issh != '1'">新建</el-button>
                </div> -->
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="table-expand">
                            <el-form-item label="头像:" class="formItem">
                                <el-image
                                style="width: 100px; height: 100px"
                                :src="props.row.header"
                                fit="cover" @click="showHeader(props.row.header)"></el-image>
                            </el-form-item>
                            <el-form-item label="昵称:">
                                <div class="row">
                                    <span>{{ props.row.nickName }}</span>
                                </div>
                            </el-form-item>
                            <el-form-item label="性别:">
                                <span>{{ props.row.gender==1?'男':'女' }}</span>
                            </el-form-item>
                            <el-form-item label="城市:">
                                <span>{{ props.row.city }}</span>
                            </el-form-item>
                            <el-form-item label="主题:">
                                <span>{{ props.row.zhuTi }}</span>
                            </el-form-item>
                            <el-form-item label="期待标签:">
                                <span>{{ props.row.yaoQiu }}</span>
                            </el-form-item>
                            <el-form-item label="动态内容:">
                                <span>{{ props.row.content }}</span>
                            </el-form-item>
                            <el-form-item label="发布时间:">
                                <span>{{ props.row.creationTime }}</span>
                            </el-form-item>
                            <el-form-item label="发布图片:" class="formItem" v-if="props.row.paths">
                                <el-image
                                style="width: 100px; height: 100px"
                                :src="item"
                                fit="cover" @click="showHeader(item)" v-for="(item,index) in props.row.paths.split(',')" :key="index"></el-image>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="nickName"
                label="昵称"
                align="center"
                >
                <template slot-scope="scope">
                    <span>{{ scope.row.nickName }}</span>
                    <span v-if="scope.row.isReal">(*)</span>
                    <span v-else></span>
                </template>
                </el-table-column>
                <el-table-column
                prop="gender"
                label="性别"
                align="center"
                width="60"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.gender==1">男</span>
                        <span v-else>女</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                prop="isJUser"
                label="是否真实用户"
                align="center"
                width="80px"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isJUser">真实用户</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column> -->
                
                <el-table-column
                prop="userId"
                label="用户Id"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="province"
                label="省份"
                align="center"
                width="80"
                >
                </el-table-column>
                <el-table-column
                prop="city"
                label="城市"
                align="center"
                width="80"
                >
                </el-table-column>

                <!-- <el-table-column
                prop="dateStringFromNow"
                label="发布时间"
                align="center"
                >
                </el-table-column> -->
                
                <el-table-column
                prop="zhuTi"
                label="话题"
                align="center"
                width="80"
                >
                </el-table-column>
                
                <el-table-column
                prop="yaoQius"
                label="期待标签"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="content"
                label="动态内容"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="state"
                label="账号状态"
                align="center"
                >
                <template slot-scope="scope">
                    {{ scope.row.state==-3?'拉黑':'' }}
                    {{ scope.row.state==-2?'注销':'' }}
                    {{ scope.row.state==-1?'冻结':'' }}
                    {{ scope.row.state==0?'审核中':'' }}
                    {{ scope.row.state==1?'正常':'' }}
                </template>
                </el-table-column>
                <el-table-column
                prop="creationTime"
                label="发布时间"
                align="center"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="120px"
                align="center"
                >
                <template slot-scope="scope">
                    <!-- <el-button type="text" icon="el-icon-edit" size="mini" @click="editTip(scope.row)">编辑</el-button> -->
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteTip(scope.row)">删除</el-button>
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="chuli(scope.row)">处理</el-button>
                </template>
                </el-table-column>
            </el-table>


            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
                
            </div>
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增动态" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户
                    </div>
                    <div class="value">
                        <el-input v-model="addData.nickName" size="small" placeholder="请输入" disabled></el-input>
                        <el-button type="primary" size="small" @click="isSelectUserDialog = true">选择用户</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        话题
                    </div>
                    <div class="value">
                        <el-select v-model="addData.zhuTi" placeholder="请选择">
                            <el-option
                            v-for="item in zhuTiList"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        期待标签
                    </div>
                    <div class="value">
                        <el-select v-model="tags" multiple placeholder="请选择">
                            <el-option
                            v-for="item in tagsList"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name">
                            </el-option>
                        </el-select>
                        <!-- <el-input v-model="addData.tag" size="small" placeholder="请输入" ></el-input> -->
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        城市
                    </div>
                    <div class="value">
                        <el-input v-model="addData.city" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        动态内容(选填,需审核)
                    </div>
                    <div class="value">
                        <el-input v-model="addData.content" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        上传图片(选填,需审核)
                    </div>
                    <div class="value">
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="addImg"
                            >
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
                
                <div class="picList">
                    <div class="pic" v-for="(item,index) in temPaths" :key="index">
                        <el-image
                        style="width: 100px; height: 100px"
                        :src="item"
                        :preview-src-list="[item]"
                        :fit="cover"
                        ></el-image>
                        <img class="pic-edit" src="../../../assets/images/icon08.png" alt="" @click="clear(index)">
                    </div>
                </div>
                    
                
                       
                <div class="item">
                    <el-switch
                    v-model="addData.baoMing"
                    active-text="允许报名"
                    inactive-text="">
                    </el-switch>
                </div>

                <div class="btns">
                    <el-button type="primary" @click="add">确认新增</el-button>
                </div>
                
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isEditDialog" title="编辑动态" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户
                    </div>
                    <div class="value">
                        <el-input v-model="editData.nickName" size="small" placeholder="请输入" disabled></el-input>
                        <el-button type="primary" size="small" @click="isSelectUserDialog = true">选择用户</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        话题
                    </div>
                    <div class="value">
                        <el-input v-model="editData.zhuTi" size="small" placeholder="请输入"></el-input>

                        <!-- <el-select v-model="editData.zhuTi" placeholder="请选择">
                            <el-option
                            v-for="item in zhuTiList"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name">
                            </el-option>
                        </el-select> -->
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        期待标签
                    </div>
                    <div class="value">
                        <el-input v-model="editData.yaoQius" size="small" placeholder="请输入"></el-input>

                        <!-- <el-select v-model="tags" multiple placeholder="请选择">
                            <el-option
                            v-for="item in tagsList"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name">
                            </el-option>
                        </el-select> -->
                        <!-- <el-input v-model="editData.tag" size="small" placeholder="请输入" ></el-input> -->
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        城市
                    </div>
                    <div class="value">
                        <el-input v-model="editData.city" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        动态内容(选填,需审核)
                    </div>
                    <div class="value">
                        <el-input v-model="editData.content" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        上传图片(选填,需审核)
                    </div>
                    <div class="value">
                        <!-- <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="editImg"
                            >
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload> -->
                    </div>
                </div>
                
                <div class="picList">
                    <div class="pic" v-for="(item,index) in temPaths" :key="index">
                        <el-image
                        style="width: 100px; height: 100px"
                        :src="item"
                        :preview-src-list="[item]"
                        :fit="cover"
                        ></el-image>
                        <img class="pic-edit" src="../../../assets/images/icon08.png" alt="" @click="clear(index)">
                    </div>
                </div>
                    
                
                       
                <div class="item">
                    <el-switch
                    v-model="addData.baoMing"
                    active-text="允许报名"
                    inactive-text="">
                    </el-switch>
                </div>

                <div class="btns">
                    <el-button type="primary" @click="edit">确认新增</el-button>
                </div>
                
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isSelectUserDialog" title="选择用户" width="1200px">
            <div class="condition">
                <div class="item">
                    <div class="label">手机号:</div>
                    <el-input v-model="userConditionData.phone" size="small" placeholder="请输入"></el-input>
                </div>
                <div class="item">
                    <div class="label">城市:</div>
                    <el-input v-model="userConditionData.City" size="small" placeholder="请输入"></el-input>
                </div>
            
                <div class="item">
                    <div class="label">性别:</div>
                    <el-select v-model="userConditionData.gender" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in genderList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            
                
                <div class="btns">
                    <el-button type="primary" size="small" @click="selectUserList()">查询</el-button>
                    <el-button type="warning" size="small" @click="resetUserList()">重置</el-button>
                </div>
            </div>
            <el-table
                :data="userList"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="table-expand">
                            <el-form-item label="用户账号:">
                                <div class="row">
                                    <span>{{ props.row.phone }}</span>
                                    <div class="btn">
                                        <el-button type="text" @click="showHeader(props.row.header)">(查看头像)</el-button>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="情感:">
                                <span>{{ props.row.love }}</span>
                            </el-form-item>
                            <el-form-item label="金币数量:">
                                <div class="row">
                                    <span>{{ props.row.jinBi }}</span>
                                    <div class="btn">
                                        <el-button type="text" @click="showHeader(props.row.header)">(修改)</el-button>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="用户昵称:">
                                <span>{{ props.row.nickName }}</span>
                            </el-form-item>
                            <el-form-item label="微信:">
                                <span>{{ props.row.weChat }}</span>
                            </el-form-item>
                            <el-form-item label="主页查看次数:">
                                <span>{{ props.row.lookInfoNumber }}</span>
                            </el-form-item>
                            <el-form-item label="性别:">
                                <span>{{ props.row.gender==1?'男':'女' }}</span>
                            </el-form-item>
                            <el-form-item label="标签:">
                                <span>{{ props.row.tag?props.row.tag:'暂无' }}</span>
                            </el-form-item>
                            <el-form-item label="查看微信次数:">
                                <span>{{ props.row.unlockNumber }}</span>
                            </el-form-item>
                            <el-form-item label="年龄:">
                                <span>{{ props.row.age }}岁</span>
                            </el-form-item>
                            <el-form-item label="支付宝账号:">
                                <span>{{ props.row.aliPayAccount }}</span>
                            </el-form-item>
                            <el-form-item label="发表动态次数:">
                                <span>{{ props.row.dynamicNumber }}</span>
                            </el-form-item>
                            <el-form-item label="城市:">
                                <span>{{ props.row.city }}</span>
                            </el-form-item>
                            <el-form-item label="真实姓名:">
                                <span>{{ props.row.realName }}</span>
                            </el-form-item>
                            <el-form-item label="相册详情:">
                                <div class="btn">
                                    <el-button type="text" @click="dynamicNumberDialog(props.row)">点击查看</el-button>
                                </div>
                            </el-form-item>
                            <el-form-item label="职业:">
                                <span>{{ props.row.zhiYe }}</span>
                            </el-form-item>
                            <el-form-item label="真人验证:">
                                <span>
                                    {{ props.row.zhenRen==-1?'认证失败':'' }}
                                    {{ props.row.zhenRen==0?'未认证':'' }}
                                    {{ props.row.zhenRen==1?'认证中':'' }}
                                    {{ props.row.zhenRen==2?'已认证':'' }}
                                </span>
                            </el-form-item>
                            <el-form-item label="动态详情:">
                                <div class="btn">
                                    <el-button type="text" @click="dynamicNumberDialog(props.row)">点击查看</el-button>
                                </div>
                            </el-form-item>
                            <el-form-item label="身高:">
                                <span>{{ props.row.shenGao }}</span>
                            </el-form-item>
                            <el-form-item label="VIP状态:">
                                <span>{{ props.row.vip?'是，':'否' }} {{ props.row.vipEndDate }}</span>
                            </el-form-item>
                            <el-form-item label="设备信息:">
                                <span>{{ props.row.deviceBrand }}(IMEI:{{ props.row.deviceId }})</span>
                                 <!-- {{ props.row.deviceName }}  -->
                            </el-form-item>
                            <el-form-item label="体重:">
                                <span>{{ props.row.tiZhong }}</span>
                            </el-form-item>
                            <el-form-item label="账号状态:">
                                <span>
                                    {{ props.row.enable==-3?'拉黑':'' }}
                                    {{ props.row.enable==-2?'注销':'' }}
                                    {{ props.row.enable==-1?'冻结':'' }}
                                    {{ props.row.enable==0?'审核中':'' }}
                                    {{ props.row.enable==1?'正常':'' }}
                                    (IP地址:{{ props.row.loginIp }})
                                </span>
                            </el-form-item>
                            <el-form-item label="最后操作时间:">
                                <span>{{ props.row.loginTime }}</span>
                            </el-form-item>
                        </el-form>
                        
                    </template>
                    </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="phone"
                label="账号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="nickName"
                label="用户昵称"
                align="center"
                >
                </el-table-column>
                
                <el-table-column
                prop="gender"
                label="性别"
                align="center"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.gender==1">男</span>
                        <span v-else>女</span>
                    </template>
                </el-table-column>

                
                <el-table-column
                prop="city"
                label="城市"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="newUser"
                label="是否虚拟账号"
                align="center"
                >
                 <template slot-scope="scope">
                    <span>{{!scope.row.newUser?'是':''}}</span>
                    <span>{{scope.row.newUser?'否':''}}</span>
                </template>
                </el-table-column>
                
                <el-table-column
                fixed="right"
                label="操作"
                width="200px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="selectUser(scope.row)">确认选择</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChangeUser"
                    background
                    layout="prev, pager, next"
                    :total="userTotalCount"
                    :current-page="userConditionData.current"
                    :page-size="userConditionData.size">
                </el-pagination>
                
            </div>
        </el-dialog>
        

        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
        <el-dialog :close-on-click-modal="false" :visible.sync="isChuliDialog" title="处理" width="640px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        处理情况
                    </div>
                    <div class="value">
                        <el-select v-model="chuliData.type" placeholder="请选择">
                            <el-option
                            v-for="item in resultList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-button type="primary" icon="el-icon-edit" @click="chuliDynamic()">确认</el-button>
                </div>

            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import {uploadTX} from '../../../utils/uploadImgTX/index'
import {parseTimeS} from '../../../utils/index'
import {genderList,vipList,shenHeList,enableList} from '../../../assets/selectList/anxin'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import M from 'minimatch'
export default {
    name: 'user',
    data () {
        return {
            mipu_issh: localStorage.getItem('mipu_issh'),
            vipList:vipList,
            enableList:enableList,
            genderList:genderList,
            shenHeList:shenHeList,
            isShow:false,
            totalCount:0,
            isDetailDialog:false,
            detailData:{},
            addData:{
                userId:null,
                nickName:"",
                gender:1,
                zhuTi:"",
                yaoQiu:"",
                city:"",
                content:"",
                paths:'',
                baoMing:false,
            },
            editData:{
                userId:null,
                nickName:"",
                gender:1,
                zhuTi:"",
                yaoQiu:"",
                city:"",
                content:"",
                paths:'',
                baoMing:false,
            },
            piclist:[],
            conditionData:{
                
                current:1,
                size:10,
            },
            tableData:[],
           

            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,
            userId:'',
            // 交换次数
            isSetUnlockNumber:false,
            setUnlockNumberData:{},
            // 会员设置
            isVip:false,
            vipData:{},
            // 动态次数
            isDynamicNumberDialog:false,
            dynamicNumberData:{},

            params:{
                current: 1,
                size: 10,
            },
            isAddDialog:false,
            isEditDialog:false,
            uploadUrl:'',
            
            userName:'',
            isSelectUserDialog:false,
            userList:[],
            userTotalCount:0,
            userConditionData:{
                phone:'',
                current:1,
                size:10,
            },
            temPaths:[],
            tags:[],
            tagsList:[],
            zhuTiList:[],

            isChuliDialog:false,
            chuliData:{
                "id": null,
                "userId": null,
                "type": 3,
                "reason": ""
            },
            resultList:[
                // {
                //     label:'将用户微信号换手机号',
                //     value:1,
                // },
                // {
                //     label:'删除用户',
                //     value:2,
                // },
                {
                    label:'冻结用户',
                    value:3,
                },
                {
                    label:'删除动态',
                    value:4,
                }
            ]
        }
    },
    components:{
        ElImageViewer
    },
    created(){

    },
    mounted(){
        this.loadingData();
        this.getUserList();
        this.UserGetYaoQiu();
        this.UserGetZhuTi();
    },
    methods:{
        async chuli(row){
            this.chuliData = {
                "id": row.id,
                "userId": row.userId,
                "type": 3,
                "reason": ""
            }
            this.isChuliDialog = true;
        },
        async chuliDynamic(){
            console.log(this.chuliData);
            let res = await api.chuliDynamic(this.chuliData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '已处理完成'
                });
                this.isChuliDialog = false;
                this.loadingData();
            }
        },
        async GetAdminYaoQiu(id){
            let res = await api.GetAdminYaoQiu(id);
            console.log(id);
            console.log(res);
            if (res.data.code === 200) {
                this.tagsList = res.data.data
            }
        },
        clear(index){
            this.temPaths.splice(index,1)
        },
        deleteTip(item){
            this.$confirm('将删除此动态?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async del(item){
            let res = await api.DynamicDeleteAsync({
                id:item.id
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });  
                this.loadingData();
            }
        },
        editTip(item){
            this.isEditDialog = true;
            this.editData = item;
            this.temPaths = item.paths.split(',')
            this.tags = item.yaoQiu.split('#');
            for(let index=this.tags.length;index>=0;index--){
                if(!this.tags[index]){
                    this.tags.splice(index, 1);
                }
            }
        },
        async edit(){
            this.editData.yaoQiu = '#' + this.tags.join('#') + '#';
            this.editData.paths = this.temPaths.join(',');
            let res = await api.DynamicEdit(this.editData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功'
                });  
                this.isEditDialog = false;
                this.loadingData();
                this.editData = {
                    userId:null,
                    nickName:"",
                    gender:1,
                    zhuTi:"",
                    yaoQiu:"",
                    city:"",
                    content:"",
                    paths:'',
                    baoMing:false,
                }
                this.temPaths=[];
                this.tags=[];
            }
        },
        async UserGetYaoQiu(){
            let res = await api.UserGetYaoQiu();
            if (res.data.code === 200) {
                this.tagsList = res.data.data
            }
        },
        
        async UserGetZhuTi(){
            let res = await api.UserGetZhuTi();
            if (res.data.code === 200) {
                this.zhuTiList = res.data.data
            }
        },
        async add(){
            console.log(this.addData);
            console.log(this.temPaths);
            console.log(this.tags);

            this.addData.yaoQiu = '#' + this.tags.join('#') + '#';
            this.addData.paths = this.temPaths.join(',');
            // return;
            let res = await api.AdminStandCreateAsync(this.addData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功'
                });  
                this.isAddDialog = false;
                this.loadingData();
                this.addData = {
                    userId:null,
                    nickName:"",
                    gender:1,
                    zhuTi:"",
                    yaoQiu:"",
                    city:"",
                    content:"",
                    paths:'',
                    baoMing:false,
                }
                this.temPaths=[];
                this.tags=[];
            }
        },
        selectUserList(){
            this.userConditionData.current = 1;
            this.getUserList();
        },
        resetUserList(){
            this.userConditionData={
                gender:null,
                phone:'',
                current:1,
                size:10,
            }
            this.getUserList();
        },
        async getUserList(){
            let res  = await api.UserInfoPager(this.userConditionData);
            console.log(res);
            this.userList = res.data.data.records;
            this.userTotalCount = res.data.data.total;
            // this.userTotalCount = 100;
            
        },
        selectUser(row){
            console.log(row);
            this.addData.userId = row.userId;
            this.addData.nickName = row.nickName;
            this.addData.gender = row.gender;
            this.addData.header = row.header;
            this.isSelectUserDialog = false;
            this.GetAdminYaoQiu(row.userId);
        },
        handleCurrentChangeUser(page){
            this.userConditionData.current = page;
            this.getUserList();
        },

        async addImg(file){
            let res = await uploadTX(file.file);
            console.log(res)
            this.temPaths.push(res);
        },
        addDialogShow(){
            this.isAddDialog = true;
        },
        delItemTip(){
            this.$confirm('将删除此动态, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async delItem(){
            let res = await api.DynamicPager({

            });
        },
        // 动态次数
        dynamicNumberDialog(row){
            console.log(row);
            this.isDynamicNumberDialog = true;
            this.dynamicNumberData = {
                "userId": row.userId,
                "dynamicNumber": row.dynamicNumber,
            };
        },
        async setDynamicNumberData(){
            this.isDynamicNumberDialog = false;
            this.dynamicNumberData.dynamicNumber = parseFloat(this.dynamicNumberData.dynamicNumber)
            let res = await api.setDynamicNumber(this.dynamicNumberData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '设置成功!'
                });
                this.loadingData();
            }
        },
        // 设置vip
        vip(row){
            console.log(row);
            this.isVip = true;
            this.vipData = {
                "userId": row.userId,
                "vip": row.vip,
            };
        },
        async setVip(){
            this.isVip = false;
            let res = await api.setVip(this.vipData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '设置成功!'
                });
                this.loadingData();
            }
        },
        // 交换次数
        setUnlockNumber(row){
            this.isSetUnlockNumber = true;
            this.setUnlockNumberData = {
                "userId": row.userId,
                "unlockNumber": row.unlockNumber,
            };
        },
        async setUnlockNumberApi(){
            this.isSetUnlockNumber = false;
            this.setUnlockNumberData.unlockNumber = parseFloat(this.setUnlockNumberData.unlockNumber)
            let res = await api.setUnlockNumber(this.setUnlockNumberData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '设置成功!'
                });
                this.loadingData();
            }
        },
        // 冻结提示
        dongjieTip(item){
            this.$confirm('将冻结用户?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.dongjie(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async dongjie(item){
            let res = await api.frozen(item.userId);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '冻结成功!'
                });
                this.loadingData();
            }
        },
        auditUser(row){
        },
        // 审核图片
        async auditPic(item){
            console.log(item);
            this.$confirm('将审核通过?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.auditPicApi(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
            return
        },
        async auditPicApi(item){
            let res = await api.shenHeUserInfoPic({
                userId:item.userId,
                userInfoPicId:item.id,
                shenHe:2,
            });
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '审核成功!'
                });
                this.isDetailDialogShow({userId:this.userId});
            }
        },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        showHeader(url){
            this.showBigImgList = [url];
            this.showBigImg = true;
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.DynamicList(this.conditionData);
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
            for(let i in this.tableData){
                // this.tableData.yaoQiu = this.tableData.yaoQiuList
                this.tableData[i].yaoQiu = '#'
                for(let j in this.tableData[i].yaoQiuList){
                    this.tableData[i].yaoQiu = this.tableData[i].yaoQiu + this.tableData[i].yaoQiuList[j] + '#'
                }
            }
            // this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.current = 1;
            this.loadingData();
        },
      
        
        
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },

        async isDetailDialogShow(row){
            this.isDetailDialog = true;
            // this.detailData = row;
            this.userId = row.userId;
            let res = await api.queryUserInfoPicByUserId(row.userId);
            console.log(res);
            this.piclist = res.data.data;

        },
       
        // 重置
        reset(){
            this.conditionData = {
                gender:null,
                phone:'',
                current: 1,
                size: 10,
            },
            this.loadingData();
        },
        
        
        
       
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
            
        }
        
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .formItem{
            display: flex;
            align-items: center;
        }
        /deep/.table-expand {
            font-size: 0;
        }
        .row{
            display: flex;
        }
        /deep/.table-expand label {
            width: 150px;
            padding-left: 50px;
            color: #99a9bf;
        }
        /deep/.table-expand span {
            color: #222222;
        }
        /deep/.table-expand .btn span{
            color: #409eff;
        }
        /deep/.table-expand .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 450px;
            // display: flex;
            // align-items: center;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 150px;
                margin-bottom: 5px;
            }
            .value{
                display: flex;
                width: 400px;
            }
            .input{
                width: 215px;
                display: flex;
            }
        }
        .picList{
            display: flex;
            flex-wrap: wrap;
            margin:0 10px;
            .pic{
                position: relative;
                margin: 5px;
                width: 100px;
                height: 100px;
                .pic-edit{
                    position: absolute;
                    z-index: 10;
                    top: -10px;
                    right: -10px;
                    width: 22px;
                    height: 22px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    i{
                        color: #ffffff;
                    }
                    .error{
                        color: #f56c6c;
                    }
                    .success{
                        color: #a9ffa9;
                    }
                }
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            justify-content: center;
            .el-button{
                margin-right: 10px;
            }
        }
    }
</style>
